// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * LabelFlow Master Dropdown Design
 * Shared dropdown styles for ProjectManagement, ModelManagement, and other pages.
 * Use labelflow-dropdown-* classes for consistent dropdown UX across the project.
 */
/* Trigger wrapper – for click-outside detection */
.labelflow-dropdown-trigger {
  position: relative;
  display: inline-flex;
}

/* Trigger button – ellipsis/more actions */
.labelflow-dropdown-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.35rem 0.5rem;
  font-size: 0.9rem;
  background: transparent;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 6px;
  color: var(--muted-foreground, #64748b);
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}
.labelflow-dropdown-btn:hover {
  background: var(--muted, #f1f5f9);
  border-color: var(--border-strong);
  color: var(--foreground, #0f172a);
}

/* Portal container – renders via ReactDOM.createPortal to document.body */
.labelflow-dropdown-portal {
  animation: labelflow-dropdown-fade 0.15s ease-out;
}

/* Menu container */
.labelflow-dropdown-menu {
  min-width: 180px;
  background: var(--card, #fff);
  border-radius: 8px;
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--border, #e2e8f0);
  padding: 0.35rem 0;
  overflow: hidden;
}

/* Menu item */
.labelflow-dropdown-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  color: var(--foreground, #0f172a);
  background: none;
  border: none;
  cursor: pointer;
  transition: background 0.15s ease;
  text-align: left;
  gap: 0.5rem;
}
.labelflow-dropdown-item i, .labelflow-dropdown-item .feather, .labelflow-dropdown-item [class^=icon-] {
  flex-shrink: 0;
  width: 1rem;
  text-align: center;
}
.labelflow-dropdown-item:hover {
  background: var(--muted, #f1f5f9);
}
.labelflow-dropdown-item--danger {
  color: var(--destructive, #dc3545);
}
.labelflow-dropdown-item--danger:hover {
  background: var(--destructive-soft);
}

/* Divider between items */
.labelflow-dropdown-divider {
  height: 1px;
  background: var(--border, #e2e8f0);
  margin: 0.25rem 0;
}

@keyframes labelflow-dropdown-fade {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/*# sourceMappingURL=dropdown-master.css.map */
`, "",{"version":3,"sources":["webpack://./src/styles/dropdown-master.css","webpack://./src/styles/dropdown-master.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;EAAA;AAWA,kDAAA;AACA;EACE,kBAAA;EACA,oBAAA;ADJF;;ACOA,2CAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,iBAAA;EACA,uBAAA;EACA,wCAAA;EACA,kBAAA;EACA,uCAAA;EACA,eAAA;EACA,yEAAA;ADJF;ACME;EACE,iCAzBc;EA0Bd,kCAAA;EACA,iCA1BM;ADsBV;;ACQA,0EAAA;AACA;EACE,iDAAA;ADLF;;ACQA,mBAAA;AACA;EACE,gBAAA;EACA,6BAAA;EACA,kBAtCU;EAuCV,4BAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;ADLF;;ACQA,cAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,iBAAA;EACA,iCArDQ;EAsDR,gBAAA;EACA,YAAA;EACA,eAAA;EACA,iCAAA;EACA,gBAAA;EACA,WAAA;ADLF;ACOE;EACE,cAAA;EACA,WAAA;EACA,kBAAA;ADLJ;ACQE;EACE,iCArEc;AD+DlB;ACSE;EACE,kCAAA;ADPJ;ACSI;EACE,mCAAA;ADPN;;ACYA,0BAAA;AACA;EACE,WAAA;EACA,kCArFU;EAsFV,iBAAA;ADTF;;ACYA;EACE;IACE,UAAA;IACA,0BAAA;EDTF;ECWA;IACE,UAAA;IACA,wBAAA;EDTF;AACF;;AAEA,8CAA8C","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
